import { Injectable } from '@angular/core';
import { APIWrapperService } from './api-wrapper.service';
import { AWSHelperService } from './aws4-helper.service';
import { allURLS } from './allURL';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  apiUrl = environment.api_endpoint;
  host: string = this.awsHelper.getHost('/profile-info');

  constructor(
    private APIWrapperService: APIWrapperService,
    private awsHelper: AWSHelperService,
    private http: HttpClient
  ) {}

  // get customer list detail.
  getUsersDetails(payload: any) {
    return this.http.post(this.apiUrl, payload).toPromise();
  }

  // get notifications
  getUserNotifications(payload: any) {
    return this.http.post(this.apiUrl, payload).toPromise();
  }
}
